<template>
  <div
    draggable  ="true"
    @dragstart ="dragStart(icon, $event)"
    class      ="icon">
    <img draggable="false" :title="icon.name" :src="icon.image">
  </div>
</template>

<script lang="">
export default {
  // Options / Data
  data () {
    return {}
  },
  props: [
    'icon'
  ],
  computed : {},
  methods  : {
    dragStart () {
      this.$eventHub.$emit('object-pick', {
        id          : this.getUniqueString(),
        type        : 'icon',
        width       : 100,
        height      : 100,
        borderColor : 'rgba(218,179,0,1)',
        iconId      : this.icon.id,
        scale       : 100,
        range       : 1,
        label       : ''
      })
    }
  }
}
</script>

<style scoped>
.icon {
  position         : relative;
  margin           : 5px;
  width            : 60px;
  height           : 60px;
  background-color : blue;
  display          : inline-block;
}

img {
  width  : 100%;
  height : auto;
}
</style>



// WEBPACK FOOTER //
// src/components/popup-window/draggable-icon.vue